import {Component} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {ActivatedRoute, RouterLink} from '@angular/router';
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {NgIf} from '@angular/common';
import {Router} from '@angular/router';
import {CustomizerSettingsService} from '../../customizer-settings/customizer-settings.service';
import {ApiService} from "../../customs/_services/api.service";
import {Endpoints} from "../../customs/endpoints";
import {HttpClientModule} from "@angular/common/http";
import {NgxSpinnerComponent} from "ngx-spinner";
import {DialogService} from "../../customs/_modal/dialog.service";
import {HandleErrorsService} from "../../services/handle-erros/handle.errors.service";
import {SecurityService} from "../../services/security-service/security.service";
import {jwtDecode} from "jwt-decode";
import { AuthService } from '../../services/user-service/AuthService';

@Component({
    selector: 'app-sign-in',
    standalone: true,
    providers: [ApiService, Endpoints, DialogService, HandleErrorsService, SecurityService],
    imports: [
        RouterLink,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatCheckboxModule,
        ReactiveFormsModule,
        NgIf,
        NgxSpinnerComponent,
        HttpClientModule],
    templateUrl: './sign-in.component.html',
    styleUrl: './sign-in.component.scss'
})
export class SignInComponent {

    isToggled = false;
    passHide = true;
    authForm: FormGroup;
    returnUrl: string;

    constructor(
        private fb: FormBuilder,
        private secService : SecurityService,
        private router: Router,
        public themeService: CustomizerSettingsService,
        private route: ActivatedRoute,
        private dialogService: DialogService,
        private handleErrors : HandleErrorsService,
        private authService: AuthService
    ) {
        this.authForm = this.fb.group({
            username: ['', [Validators.required]],
            password: ['', [Validators.required, Validators.minLength(6)]],
        });
        this.themeService.isToggled$.subscribe(isToggled => {
            this.isToggled = isToggled;
        });
    }

    onSubmit() {
    if (this.authForm.valid) {
        const username = this.authForm.value.username;
        const pw = this.authForm.value.password;
        this.secService.login(username, pw).subscribe({
        next: (response) => {
            // Ici on vérifie que response.data.token existe et est une string
            if (response.status && response.data && typeof response.data.token === 'string') {
            const token = response.data.token;
            const decodedJwt: any = jwtDecode(token);

            sessionStorage.setItem('user_token', token);
            sessionStorage.setItem('user_id', decodedJwt.id || response.data.id);
            sessionStorage.setItem('user_name', decodedJwt.name || response.data.name);
            sessionStorage.setItem('user_username', decodedJwt.sub || response.data.username);
            sessionStorage.setItem('user_roles', decodedJwt.scope || response.data.roles.join(' '));

            this.authService.setUserInfo(decodedJwt.name || response.data.name, decodedJwt.scope || response.data.roles.join(' '));

            let defaultUrl = '';
            this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || defaultUrl;
            this.router.navigateByUrl('/', { skipLocationChange: false }).then(() => {
                this.router.navigate(['/']);
            });
            } else {
            console.error('❌ Token JWT manquant ou invalide dans la réponse :', response);
            this.dialogService.openDangerDialog("Erreur d'authentification. Veuillez réessayer.");
            }
        },
        error: (err) => {
            this.handleErrors.catchError(err);
        }
        });
    } else {
        this.dialogService.openDangerDialog('Form is invalid. Please check the fields.');
    }
    }

}
